export default {
  common: {
    nav: {
      home: "首页",
      find_offer_help: "寻求 / 提供帮助",
      celebrate: "纪念一段人生",
      family_tree: "家谱",
      events: "活动",
      civic_reports: "民生报告",
      neighborhood_pulse: "社区动态",
      weather: "天气",
      nature: "自然",
      marketplace: "市集",
      news: "新闻",
      causes: "公益",
      more: "更多",
    },
    header: { sign_in: "登录", join: "加入 Social Pulse", language: "语言", search: "搜索" },
    tagline: "连接社区 · 赋能生活 · 构建社会资本",
    locality: {
      viewing_from: "您正在浏览来自",
      help_improve: "帮助我们改进您的位置",
      filter_by_country: "按国家/地区筛选",
      change: "更改",
      set_your_location: "设置您的位置",
      set_your_location_hint: "— 点击以个性化",
    },
    actions: {
      submit_cause: "提交公益诉求",
      make_donation: "支持 Social Pulse 全球倡议 — 立即捐赠",
      browse_all: "浏览所有栏目",
    },
    news: {
      title: "您的每日简报。",
      submit_news: "提交新闻",
      archive: "档案",
      weather_nature: "天气与自然",
      play_briefing: "播放每日简报",
      play_briefing_hint: "收听热门 {{count}} 条新闻 · 约 {{minutes}} 分钟 · 以您的语言",
      read_original: "阅读原文",
      view_brief: "查看简报",
      also_reported_by: "同时报道:",
      translate: "翻译",
      listen: "收听",
      stop: "停止",
    },
  },
};
